// extracted by mini-css-extract-plugin
module.exports = {"container":"OrderVolumeBlock_container__Okj5H","title":"OrderVolumeBlock_title__fPCQj","error":"OrderVolumeBlock_error__Y_Kjn"};